import React, { FunctionComponent, useMemo } from 'react';

type Props = {
  current: number;
  max: number;
  page?: string;
  paddingClass?: string;
  handleClick: (page: number) => any;
};

export const Presentation: FunctionComponent<Props> = ({ current, max, page, paddingClass, handleClick }) => {
  const className = page === 'companyIndex' ? 'pagination center' : 'pagination';
  const paddingProps = paddingClass === 'padding' ? 'padding' : '';

  const isNarrow = page === 'companyMessageBox';
  const rangeSize = isNarrow ? 1 : 2;

  const { start, end } = useMemo(() => {
    const s = current < (rangeSize + 1) ? 1 : (current - rangeSize);
    const e = max > current + rangeSize ? current + rangeSize : max;
    return { start: s, end: e };
  }, [current, max, rangeSize]);

  const range = useMemo(
    () => Array.from({ length: end - start + 1 }, (_, i) => i + start),
    [start, end]
  );

  return (
    <nav className={`${className} ${paddingProps} ${isNarrow ? 'narrow' : ''}`} role="navigation" aria-label="pager">
      {current !== 1 && (
        <>
          <span className="first" onClick={() => handleClick(1)}>
            <i className="fa fa-angle-double-left fa-lg" style={{ cursor: 'pointer' }} />
          </span>
          <span className="prev" onClick={() => handleClick(current - 1)}>
            <a>前</a>
          </span>
        </>
      )}

      {((!isNarrow && current - rangeSize > 1) ||
        (isNarrow && max > 2 && current === max)) && <span className="page gap">...</span>}

      {range.map((p) => (
        <span
          key={p}
          className={`page ${p === current ? 'current' : ''}`}
          onClick={() => handleClick(p)}
        >
          {p === current ? p : <a>{p}</a>}
        </span>
      ))}

      {((!isNarrow && current + rangeSize < max) ||
        (isNarrow && max > 2 && current === 1)) && <span className="page gap">...</span>}

      {current !== max && (
        <>
          <span className="next" onClick={() => handleClick(current + 1)}>
            <a>次</a>
          </span>
          <span className="last" onClick={() => handleClick(max)}>
            <i className="fa fa-angle-double-right fa-lg" style={{ cursor: 'pointer' }} />
          </span>
        </>
      )}
    </nav>
  );
};
